<div class="plan-panel-list">
  <div class="plan-panel-item" *ngFor="let plan of plans; let i = index; let last = last">
    <div class="plan-header" (click)="togglePanel(i)">
      <div class="plan-main-info">
        <div class="plan-name">
          <span class="label">{{ 'components.planPanel.plan' | i18n }}</span>
          <span class="value">{{ getFormattedPlanName(plan) }}</span>
        </div>
        <div class="separator">|</div>
        <div class="plan-quantity">
          <span class="label">{{ 'components.planPanel.quantity' | i18n }}</span>
          <span class="value">
            {{ plan.quantity }} 
            {{ (plan.quantity === 1 ? 'components.planPanel.licenseSingular' : 'components.planPanel.licensePlural') | i18n }}
          </span>
        </div>
        <div class="separator">|</div>
        <div class="plan-expiration-date">
          <span class="label">{{ 'components.planPanel.expirationDate' | i18n }}</span>
          <span class="value">{{ plan.expirationDate ? (plan.expirationDate | date:'dd/MM/yyyy') : '-' }}</span>
        </div>
        <div class="separator">|</div>
        <div class="plan-total">
          <span class="label">{{ 'components.planPanel.total' | i18n }}</span>
          <span class="value">{{ (plan.price) | currencyBRL }} {{ getYearlySuffix(plan) }}</span>
        </div>
      </div>
      <div class="plan-actions-row">
        <div class="plan-status">
          <span class="status-badge" [ngClass]="getStatusClass(plan.status)">
            <span class="status-icon" [ngClass]="plan.statusIcon.class" [style.color]="plan.statusIcon.color" [attr.aria-label]="plan.statusIcon.label"></span>
            <span class="status-text">
              {{ getStatusText(plan.status) }}
            </span>
          </span>
        </div>
        <span class="material-icons toggle-icon">
          {{ isPanelOpen(i) ? 'expand_less' : 'expand_more' }}
        </span>
      </div>
    </div>
    
    <div class="plan-content" *ngIf="isPanelOpen(i)">
      <div class="plans-grid">
        <div class="plan-card">
          <div class="plan-card-name">{{ getFormattedPlanName(plan) }}</div>
          <div class="plan-card-details">
            <div class="plan-price">
              <strong>{{ getPriceLabelKey(plan) | i18n }}</strong>
              <span>{{ getMonthlyPrice(plan) | currencyBRL }}</span>
            </div>
            <div class="plan-contract-period">
              <strong>{{ 'components.planPanel.contractPeriod' | i18n }}</strong>
              <span>{{ plan.contractPeriod }}</span>
            </div>
            <div class="plan-payment-method">
              <strong>{{ 'components.planPanel.paymentMethod' | i18n }}</strong>
              <span class="payment-info">
                <img 
                  [src]="plan.cardType | getCreditCardIconSrc:(plan.flow || undefined)" 
                  [alt]="plan.cardType || ((plan.flow === 'BOLETO_CARTAO' || !plan.flow) ? ('components.planPanel.paymentBoleto' | i18n) : ('components.planPanel.paymentInvoice' | i18n))" 
                  class="card-icon"
                >
                {{ plan.cardType | paymentText:plan.cardLastFourDigits:(plan.flow || undefined) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="plan-footer">
        <div class="plan-actions">
          <button *ngIf="plan.cardType" class="btn-payment" type="button" (click)="onChangePaymentMethod(plan)">
            {{ 'components.planPanel.changePayment' | i18n }}
          </button>
          <button class="btn-details" type="button" (click)="onPlanDetails(plan.uuid)">
            {{ 'components.planPanel.planDetails' | i18n }}
          </button>
        </div>
      </div>
    </div>
    
    <div class="panel-divider" *ngIf="!last"></div>
  </div>
</div>